import * as yup from "yup";

export const validationSchema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup.string().when("youCanChangePassword", {
    is: true,
    then: yup
      .string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters long"),
    otherwise: yup.string(),
  }),
  password_confirmation: yup.string().when("youCanChangePassword", {
    is: true,
    then: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match")
      .required("Confirm password is required"),
    otherwise: yup.string(),
  }),
});
